import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { ScheduleStatusReportItem } from '@mi-front/core';
import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { AuditMediaPlayerAction } from '../../../../components/AuditMediaPlayerAction';
import { closeDialogMessage } from './schedule-status-spot-messages';
import { ScheduleStatusSpotStatusChip } from './ScheduleStatusSpotStatusChip';

interface ScheduleStatusSpotDetailHeaderProps {
  item: ScheduleStatusReportItem;
  onHide: () => void;
}

/**
 * Dialog header: material ID, coverage chip, play (when audio exists), and close.
 */
export function ScheduleStatusSpotDetailHeader({
  item,
  onHide,
}: ScheduleStatusSpotDetailHeaderProps) {
  const { $t } = useIntl();
  const station = useActiveStation();

  return (
    <DialogTitle
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1.5, flexWrap: 'nowrap' }}
    >
      <Typography variant="h6" component="span" noWrap sx={{ minWidth: 0 }}>
        {item.customId}
      </Typography>
      <ScheduleStatusSpotStatusChip status={item.status} missingAudio={!item.audio} />
      <Box sx={{ flexGrow: 1 }} />
      {item.audio && (
        <AuditMediaPlayerAction
          audio={{
            ...item.audio,
            stationId: station.id,
          }}
        />
      )}
      <Tooltip title={$t(closeDialogMessage)}>
        <IconButton onClick={onHide} sx={{ my: 0 }}>
          <CloseIcon />
        </IconButton>
      </Tooltip>
    </DialogTitle>
  );
}
